export default __webpack_public_path__ + "tmp_node_modules/swiper/swiper-bundle.min.css.liquid";